const formats = require('./formats')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {*} value
 * @param {string} format
 * @returns {*}
 */
function formatField ({ country, value, format } = {}) {
  if (!value || !format) return value
  return formats[format]({ country, value })
}

module.exports = { formatField }
